<form [formGroup]="formGroup">
	<p-accordion #accordion>
		<p-accordionTab [header]="'dynamic-form.configuration.general' | translate" formGroupName="general"
			[selected]="true">

			<div class="grid formgrid p-fluid">
				<div class="field col-12">
					<label class="ml-3 flex align-items-center gap-2" for="name">
						{{'dynamic-form.configuration.name' | translate}}
						<i id="nameInput-help" class="pi pi-info-circle" [style.color]="'#3282F3'"
							[pTooltip]="'dynamic-form.tooltip.nameInputHelp' | translate" [escape]="false" tooltipPosition="top"></i>
					</label>

					<input pInputText id="name" formControlName="name" type="text" aria-describedby="name-help"
						[maxlength]="MAX_TITLE_LENGTH" pKeyFilter="alphanum">
					<ng-container *ngIf="formGroup.get('general.name')?.invalid">
						<small id="name-help" class="p-error block">
							{{ fc.getValidationError(formGroup.get('general.name')) }}
						</small>
					</ng-container>
				</div>
				<div class="field col-12">
					<label class="ml-3" for="label">{{'dynamic-form.configuration.label' | translate}}</label>
					<input pInputText id="label" formControlName="label" type="text" aria-describedby="name-help"
						[maxlength]="MAX_TITLE_LENGTH">
					<ng-container *ngIf="formGroup.get('general.label')?.invalid">
						<small id="name-help" class="p-error block">
							{{ fc.getValidationError(formGroup.get('general.label')) }}
						</small>
					</ng-container>
				</div>

				<ng-container *ngIf="Page && control">
					<div *ngIf="typeChecker.hasPlaceholder(control)" class="field col-12">
						<label class="ml-3" for="placeholder">{{'dynamic-form.configuration.placeholder' | translate}}</label>
						<input id="placeholder" formControlName="placeholder" type="text" aria-describedby="placeholder-help"
							pInputText [maxlength]="MAX_TITLE_LENGTH">
					</div>
					<div *ngIf="typeChecker.hasTooltip(control)" class="field col-12">
						<label class="ml-3" for="tooltip">{{'dynamic-form.configuration.tooltip' | translate}}</label>
						<input id="tooltip" formControlName="tooltip" type="text" aria-describedby="tooltip-help" pInputText
							[maxlength]="MAX_TITLE_LENGTH">
					</div>
					<div *ngIf="typeChecker.isInputMask(control)" class="field col-12">
						<label class="ml-3 flex align-items-center gap-2" for="mask">
							{{'dynamic-form.configuration.mask' | translate}}
							<i id="nameInput-help" class="pi pi-info-circle" [style.color]="'#3282F3'"
								[pTooltip]="'dynamic-form.tooltip.maskInputHelp' | translate" [escape]="false"
								tooltipPosition="top"></i>
						</label>
						<input id="mask" formControlName="mask" type="text" aria-describedby="mask-help" pInputText
							[maxlength]="MAX_TITLE_LENGTH">
					</div>
					<div class="field col-12">
						<label class="ml-3" for="type">{{'dynamic-form.configuration.type' | translate}}</label>
						<p-dropdown [options]="VisibleControls" formControlName="type" appendTo="body" optionLabel="label"
							optionValue="id" autoWidth="false" [style]="{'width':'100%'}" [filter]="true"></p-dropdown>
					</div>
					<div *ngIf="typeChecker.isCalendar(control)" class="field col-12">
						<label class="ml-3" label for="dateFormat">{{'dynamic-form.configuration.dateFormat' |
							translate}}</label>
						<input pInputText id="dateFormat" formControlName="dateFormat" type="text" [maxlength]="50">
					</div>

					@if(typeChecker.hasMinMax(control)){
					<div class="field col-12">
						<label class="ml-3 flex align-items-center gap-2" for="rows">
							{{'dynamic-form.configuration.min' | translate}}
						</label>
						<p-inputNumber formControlName="min" />
					</div>
					<div class="field col-12">
						<label class="ml-3 flex align-items-center gap-2" for="rows">
							{{'dynamic-form.configuration.max' | translate}}
						</label>
						<p-inputNumber formControlName="max" />
					</div>
					}

					@if(!typeChecker.isLabel(control)){
					<div class="field col-12 container-checkbox">
						<label class="label-text block ml-3" for="isRequired">{{'dynamic-form.configuration.isRequired' |
							translate}}</label>
						<p-checkbox formControlName="isRequired" [binary]="true" inputId="isRequired"></p-checkbox>
					</div>
					}

					@if(typeChecker.hasReadonly(control)){
					<div class="field col-12 container-checkbox">
						<label class="label-text block ml-3" for="readonly">{{'common.readonly' | translate}}</label>
						<p-checkbox formControlName="readonly" [binary]="true" inputId="readonly"></p-checkbox>
					</div>
					}

					@if(typeChecker.isFileUpload(control)){
					<div class="field col-12 container-checkbox">
						<label class="label-text block ml-3" for="multipleFiles">
							{{'dynamic-form.configuration.uploadMultipleFiles' | translate}}
						</label>
						<p-checkbox formControlName="multipleFiles" [binary]="true" inputId="multipleFiles"></p-checkbox>
					</div>
					<div class="field col-12">
						<label class="ml-3" for="chooseLabel">{{'dynamic-form.configuration.chooseLabel' |
							translate}}</label>
						<input id="chooseLabel" formControlName="chooseLabel" type="text" aria-describedby="chooseLabel-help"
							pInputText [maxlength]="MAX_TITLE_LENGTH">
						<ng-container *ngIf="formGroup.get('general.chooseLabel')?.invalid">
							<small id="chooseLabel-help" class="p-error block">
								{{ fc.getValidationError(formGroup.get('general.chooseLabel')) }}
							</small>
						</ng-container>
					</div>
					<div class="field col-12">
						<label class="ml-3" for="accept">{{'dynamic-form.configuration.accept' |
							translate}}</label>
						<p-multiSelect formControlName="accept" [options]="mimeTypes" optionLabel="text" optionValue="value"
							appendTo="body" placeholder="select..." display="chip" [style]="{'width':'100%'}"></p-multiSelect>
					</div>
					}

					@if(typeChecker.hasRows(control)){
					<div class="field col-12">
						<label class="ml-3 flex align-items-center gap-2" for="rows">
							{{'dynamic-form.configuration.filas' | translate}}
							<i id="rowsInput-help" class="pi pi-info-circle" [style.color]="'#3282F3'"
								[pTooltip]="'dynamic-form.tooltip.rowsInputHelp' | translate" [escape]="false"
								tooltipPosition="top"></i>
						</label>
						<p-inputNumber formControlName="rows" [min]="0" [max]="100" />
					</div>
					}

					@if(typeChecker.isSubFormulario(control)){
						<app-sub-formulario-select [control]="control" class="w-full"></app-sub-formulario-select>

            <div class="field col-12 container-checkbox">
              <label class="label-text block ml-3" for="removeAddBtn">{{'common.removerBtnAgregar' |
                translate}}</label>
              <p-checkbox formControlName="removeAddBtn" [binary]="true" inputId="removeAddBtn"></p-checkbox>
            </div>
            <div class="field col-12 container-checkbox">
              <label class="label-text block ml-3" for="removeDeleteBtn">{{'common.removerBtnEliminar' |
                translate}}</label>
              <p-checkbox formControlName="removeDeleteBtn" [binary]="true" inputId="removeDeleteBtn"></p-checkbox>
            </div>
					}
				</ng-container>
			</div>

		</p-accordionTab>

		<p-accordionTab [header]="'dynamic-form.configuration.seleccion' | translate" formGroupName="choiceOptions"
			*ngIf="Page && control && typeChecker.hasOptions(control)" class="flex flex-column gap-1">

			@if(typeChecker.hasMultiSelect(control)){
				<div class="field col-12 container-checkbox">
					<label class="label-text block ml-3 flex align-items-center gap-2" for="multiSelect">
						{{'dynamic-form.configuration.multiSelect' | translate}}
					</label>
					<p-checkbox formControlName="multiSelect" [binary]="true" inputId="multiSelect"></p-checkbox>
				</div>
			}

			<div class="grid formgrid p-fluid">
				<div *ngIf="typeChecker.hasFilter(control)" class="field col-12 container-checkbox">
					<label class="label-text block ml-3 flex align-items-center gap-2" for="addfilter">
						{{'dynamic-form.configuration.addfilter' | translate}}
						<i id="addfilter-help" class="pi pi-info-circle" [style.color]="'#3282F3'"
							[pTooltip]="'dynamic-form.tooltip.addfilterHelp' | translate" [escape]="false" tooltipPosition="top"></i>
					</label>
					<p-checkbox formControlName="addfilter" [binary]="true" inputId="addfilter"></p-checkbox>
				</div>

				<div class="field col-12">
					<label class="ml-3" for="dataSource">{{'common.dataSource' | translate}}</label>
					<p-dropdown [options]="dataSourceOptions" formControlName="dataSource" appendTo="body" optionLabel="text"
						optionValue="value" autoWidth="false" [style]="{'width':'100%'}"></p-dropdown>
				</div>
				<h4 class="field col-12">{{'dynamic-form.configuration.opciones' | translate}}</h4>
				@if(control.dataSource === dataSourceType.DatasetDinamico){
        <div class="field col-12">          
          <app-data-source-config-tram-automaticos [control]="control" class="w-full"></app-data-source-config-tram-automaticos>
        </div>
				}@else{
          <button pButton type="button" (click)="showOptionsBuilderModal()" icon="pi pi-external-link"
            [label]="'dynamic-form.configuration.editar-optiones' | translate"
            class="button-edit p-button-outlined"></button>
          <div class="field col-12">
            <p-table [columns]="control.getOptionKeys()" [value]="control.options" styleClass="p-datatable-sm"
              [scrollable]="true" scrollHeight="250px">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of control.getOptionKeys()" scope="col">
                    {{col}}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                  <td *ngFor="let col of control.getOptionKeys()">
                    {{rowData[col]}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <app-options-builder [header]="control.name" [originalOptions]="control.options"
            (onApplyOptionsEvent)="applyNewOptions($event)"></app-options-builder>
        }
        <h4 class="field col-12">{{'dynamic-form.configuration.dependencias' | translate}}</h4>
        <div class="field col-12">
          <app-dependency-builder></app-dependency-builder>
        </div>
			</div>

		</p-accordionTab>

		<p-accordionTab [header]="'dynamic-form.configuration.diseno' | translate" formGroupName="layout"
			*ngIf="Page && control">
			<div class="grid formgrid p-fluid">
				<div class="field col-12 container-checkbox">
					<label class="label-text block ml-3" for="startOnNewLine">{{'dynamic-form.configuration.startOnNewLine' |
						translate}}</label>
					<p-checkbox formControlName="startOnNewLine" [binary]="true" inputId="startOnNewLine"></p-checkbox>
				</div>
				<div class="field col-12 container-checkbox" *ngIf="typeChecker.hasShowHorizontal(control)">
					<label class="label-text block ml-3" for="showHorizontal">{{'dynamic-form.configuration.showHorizontal' |
						translate}}</label>
					<p-checkbox formControlName="showHorizontal" [binary]="true" inputId="showHorizontal"></p-checkbox>
				</div>
				<div class="field col-12" *ngIf="typeChecker.hasFontSize(control)">
					<label class="ml-3" for="fontSize">{{'dynamic-form.configuration.tamaño-fuente' | translate}}</label>
					<p-dropdown [options]="fontSize" formControlName="fontSize" appendTo="body" optionLabel="text"
						optionValue="value" autoWidth="false" [style]="{'width':'100%'}"></p-dropdown>
				</div>
				<div class="field col-12">
					<label class="ml-3" for="widthSmallScreen">{{'dynamic-form.configuration.ancho-sm' | translate}}</label>
					<p-dropdown [options]="elementWidths" formControlName="widthSmallScreen" appendTo="body" optionLabel="text"
						optionValue="value" autoWidth="false" [style]="{'width':'100%'}"></p-dropdown>
				</div>
				<div class="field col-12">
					<label class="ml-3" for="widthMediumScreen">{{'dynamic-form.configuration.ancho-md' | translate}}</label>
					<p-dropdown [options]="elementWidths" formControlName="widthMediumScreen" appendTo="body" optionLabel="text"
						optionValue="value" autoWidth="false" [style]="{'width':'100%'}"></p-dropdown>
				</div>
				<div class="field col-12">
					<label class="ml-3" for="widthLargeScreen">{{'dynamic-form.configuration.ancho-lg' | translate}}</label>
					<p-dropdown [options]="elementWidths" formControlName="widthLargeScreen" appendTo="body" optionLabel="text"
						optionValue="value" autoWidth="false" [style]="{'width':'100%'}"></p-dropdown>
				</div>
				<div class="field col-12">
					<label class="ml-3" for="widthLargerScreen">{{'dynamic-form.configuration.ancho-xl' | translate}}</label>
					<p-dropdown [options]="elementWidths" formControlName="widthLargerScreen" appendTo="body" optionLabel="text"
						optionValue="value" autoWidth="false" [style]="{'width':'100%'}"></p-dropdown>
				</div>
			</div>
		</p-accordionTab>

		<p-accordionTab [header]="'dynamic-form.configuration.condiciones' | translate" *ngIf="Page && control">

			<button pButton type="button" (click)="showConditionModal('enableIf')" icon="pi pi-external-link p-button-sm"
				[label]="'dynamic-form.configuration.edit-enable-conditions' | translate"
				class="button-edit p-button-outlined w-full"></button>
			<app-condition-builder fieldId="enableIf"
				(onApplyConditions)="applyEnableIfConditions($event)"
        [existingTokens]="control.enableIf"></app-condition-builder>

      <button pButton type="button" (click)="showConditionModal('visibleIf')" icon="pi pi-external-link p-button-sm"
				[label]="'dynamic-form.configuration.edit-visible-conditions' | translate"
				class="button-edit p-button-outlined w-full mt-1"></button>
      <app-condition-builder fieldId="visibleIf"
				(onApplyConditions)="applyVisibleIfConditions($event)"
        [existingTokens]="control.visibleIf"></app-condition-builder>

		</p-accordionTab>
	</p-accordion>
</form>